// extracted by css-extract-rspack-plugin
export default {"inputs":"e0ODa8","display-resolution":"nTm5he","displayResolution":"nTm5he"};